import qs from "qs";

import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import {
  IBaseTariffDetailResponse,
  IBaseTariffsListParams,
  IBaseTariffsListResponse,
  IUpdateBaseTariffParams,
} from "~/entity/Tariffs/model/schema";

const tariffsServiceMap = {
  root: "/tariffs",
};

export class TariffsService {
  static _routes = tariffsServiceMap;

  static GET = {
    list: (
      params?: IBaseTariffsListParams,
    ): NetworkResponse<IBaseTariffsListResponse> =>
      requestREST.get(tariffsServiceMap.root, { params }),

    byId: (id: string): NetworkResponse<IBaseTariffDetailResponse> =>
      requestREST.get(`${tariffsServiceMap.root}/${id}`),

    exportUrl: (
      params?: Omit<IBaseTariffsListParams, "page" | "count">,
    ): string => {
      const query = qs.stringify(params, { skipNulls: true });

      return `${requestREST.defaults.baseURL}${tariffsServiceMap.root}/export${
        query ? `?${query}` : ""
      }`;
    },
  };

  static PUT = {
    update: (
      id: string,
      data: IUpdateBaseTariffParams,
    ): NetworkResponse<IBaseTariffDetailResponse> =>
      requestREST.put(`${tariffsServiceMap.root}/${id}`, data),
  };
}
